import CollaborationService from '../../api/collaboration';

const state = {
  comments: [],
  commentCountsByScan: [],
};

const getters = {
  comments: (state) => {
    return state.comments;
  },
  commentCountsByScan: (state) => {
    return state.commentCountsByScan;
  },
  sortedComments: (state) => {
    let sorted = [...state.comments].sort((a, b) => {
      return new Date(a.created_date) - new Date(b.created_date);
    });
    // Loop through each comment, and check for children
    sorted.forEach((node) => {
      if (node.children) {
        // This node has children - Send into recursive helper function to sort and place returned value in node.children
        let sortedChildren = sortChildren(node.children);
        node.children = sortedChildren;
      }
    });

    function sortChildren(children) {
      let sortedChildren = children.sort((a, b) => {
        return new Date(a.created_date) - new Date(b.created_date);
      });
      // Loop through sortedChildren and see if they have any children
      sortedChildren.forEach((child) => {
        if (child.children) {
          // This child has children - Send back into this recursive helper function to sort and place return value in child.children
          let temp = sortChildren(child.children);
          child.children = temp;
        }
      });
      return sortedChildren;
    }
    return sorted;
  },
};

const actions = {
  async getComments({ commit }, payload) {
    const collabService = new CollaborationService();
    const response = await collabService.getComments(payload);
    if (response && response.data) {
      commit('setComments', response.data);
    }
  },
  async getCommentCountsByScan({ commit }, payload) {
    const collabService = new CollaborationService();
    const response = await collabService.getCommentCountsByScan(payload);
    if (response && response.data) {
      commit('setCommentCountsByScan', response.data);
    }
  },
  async addComment({ commit, dispatch, state }, payload) {
    let collabService = new CollaborationService();
    const response = await collabService.addComment(payload);

    if (response && response.success && response.data) {
      let newComment = response.data[0];

      // If the comment has a parent id, we need to find the parent comment and add this comment to its children array
      if (newComment.parent_id) {
        const comments = assignChild([...state.comments]);

        function assignChild(comments) {
          return comments.map((c) => {
            // If we've found the parent comment, add the new comment to its children array
            if (c.id === newComment.parent_id) {
              c.children
                ? c.children.push(newComment)
                : (c.children = [newComment]);
            } else if (c.children) {
              // If we haven't found the parent comment and this comment has children, send the children into this function
              c.children = assignChild(c.children, 'children');
            }
            return c;
          });
        }

        commit('setComments', comments);
      } else {
        // Comment is top level, push to comments array
        commit('setComments', [...state.comments, newComment]);
      }

      return true;
    } else {
      return false;
    }
  },
  async deleteAllCommentsByScan({ commit }, payload) {
    let collabService = new CollaborationService();
    const response = await collabService.deleteAllCommentsByScan(payload);
    if (response && response.success) {
      commit('setComments', []);
      return true;
    } else {
      return false;
    }
  },
  async deleteComments({ dispatch, state }, payload) {
    // Build array of ids to delete, starting with the comment passed in and going up the tree to delete flagged relatives
    let idsToDelete = [payload.id];

    // If the comment has a parent
    if (payload.parent_id) {
      // Execute method to traverse up the tree and find ancestors that should also be deleted
      getFlaggedAncestors(state.comments, payload.parent_id);
    }

    // Recurse through comments to find ancestors flagged for removal with no children
    function getFlaggedAncestors(comments, parentId) {
      if (!comments || !comments.length) return;

      comments.forEach((comment) => {
        // If this is the parent and it's flagged removed
        if (comment.id === parentId && comment.removed) {
          // Check if there are children that aren't being deleted
          const survivingChildren = comment.children
            ? comment.children.some((child) => !idsToDelete.includes(child.id))
            : false;

          // If the comment has no remaining children, add it to the list of ids to delete
          if (!survivingChildren) {
            idsToDelete.push(comment.id);
          }

          // If this comment has a parent, send the parent into this function to check if it should be added to the delete list
          if (comment.parent_id) {
            getFlaggedAncestors(state.comments, comment.parent_id);
          }
        }

        // If we haven't found the parent, send the comment's children into this function to check if they contain the parent
        if (comment.id !== parentId && comment.children) {
          getFlaggedAncestors(comment.children, parentId);
        }
      });
    }

    // Make request to delete comments
    let collabService = new CollaborationService();
    const response = await collabService.deleteComments(idsToDelete);

    if (response && response.success) {
      dispatch('getComments', payload.scan_id);
      return true;
    } else {
      return false;
    }
  },
  async flagCommentRemoved({ dispatch }, payload) {
    let collabService = new CollaborationService();
    const response = await collabService.flagCommentRemoved(payload.id);

    if (response && response.success) {
      dispatch('getComments', payload.scan_id);
      return true;
    } else {
      return false;
    }
  },
  clearStore({ commit }) {
    commit('setComments', []);
  },
};

const mutations = {
  setComments(state, payload) {
    state.comments = payload;
  },
  setCommentCountsByScan(state, payload) {
    state.commentCountsByScan = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
